import React, { useEffect, useState } from 'react';
import { Row, Col } from 'reactstrap';
import { faPencilAlt, faMapMarkerAlt, faCheck, faFilePdf } from '@fortawesome/free-solid-svg-icons';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import Stepper from '../../../components/Stepper/Stepper';
import IdentificacaoDestino from './components/IdentificacaoDestino';
import EnderecoDestino from './components/EnderecoDestino';
import FichaDestinoContainer from './components/FichaDestinoContainer';

//Api
import destino_api from '../../../api/destino_api';
import documento_api from '../../../api/documento_api';

//Helpers
import { validarCampos, objCampo } from '../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../helpers/message';
import { useAuth } from 'context/auth';

//Shared
import Documentos from '../../../views/Shared/Documentos';

//Estado inicial para o destino
function initialStateDestino() {
    return {
        fantasia: "",
        tipo: "final",
        razao: "",
        logradouro: "",
        numero: "",
        complemento: "",
        bairro: "",
        cidade: "",
        inscricao: "",
        responsavel: "",
        fone: "",
        cnpj: "",
        email: "",
        cep: "",
        uf: "",
        gps: "",
        latitude: "",
        longitude: "",
        tbTipoDestino_id: 0,
        tbTipoDestino_descricao: "",
        numeroLicencaOperacao: "",
        validadeLicencaOperacao: "",
        orgaoExpLicencaOperacao: "",
        protocolo_Averbacao: "",
        dataAverbacao: "",
        status: "Ativo",
        prefeituras: [],
        tiposResiduos: [],
        documentos: []
    }
}
export default function NovoDestino({ destinoParam = {}, btnVoltar }) {
    const { setLoading } = useAuth()
    //Estado para controle dos campos do destino no formulario
    const [destino, setDestino] = useState(Object.keys(destinoParam).length !== 0 ? destinoParam : initialStateDestino);

    //Estado para controle dos passos do cadastro
    const [activeStep, setActiveStep] = useState(1);

    //Estado para controle dos campos com erro
    const [errors, setErrors] = useState([]);

    //Estado para pegar os documentos para destino 
    const [listdocumentos, setListDocumentos] = useState([]);

    //Campos de validação no passo de identificação
    const camposIdentificacao = [
        objCampo({ name: "cnpj", required: true, cnpj: true }),
        objCampo({ name: "responsavel", required: true }),
        objCampo({ name: "email", required: true }),
        objCampo({ name: "fantasia", required: true }),
        objCampo({ name: "razao", required: true }),
        objCampo({ name: "fone", required: true }),
        objCampo({ name: "status", required: true }),
        objCampo({ name: "tbTipoDestino_id", required: true }),
        objCampo({ name: "tiposResiduos", required: true }),
        objCampo({ name: "email", required: true, email: true })
    ]

    //Campos de validação no passo de endereço
    const camposEndereco = [
        { name: "cep", required: true },
        { name: "uf", required: true },
        { name: "cidade", required: true },
        { name: "bairro", required: true },
        { name: "logradouro", required: true },
        { name: "numero", required: true },
    ]

    //Função que valida os campos de identificação
    function validarIdentificacao() {
        const erros = validarCampos(destino, camposIdentificacao);
        setErrors(erros[0]);
        return erros[1];
    }

    //Função que valida os campos do endereço
    function validarEndereco() {
        const erros = validarCampos(destino, camposEndereco);
        setErrors(erros[0]);
        return erros[1];
    }


    function onChangeDocumentos(documento) {
        const _destino = { ...destino };
        const existeDocumento = _destino.documentos.findIndex(x => x.tbDocumentos_Id === documento.tbDocumentos_Id);

        if (existeDocumento === -1) {
            _destino.documentos = [..._destino.documentos, {
                ...documento,
                tbDestino_Id: _destino.id ? _destino.id : null
            }];
        } else {
            _destino.documentos[existeDocumento] = {
                ..._destino.documentos[existeDocumento],
                ...documento
            };
        }
        setDestino(_destino);
    }

    const validarDocumentos = () => {
        const documentosObrigatorios = listdocumentos.filter(doc => doc.obrigatorio);
        const todosDocumentosPresentes = documentosObrigatorios.every(obrigatorioDoc =>
            destino?.documentos?.some(doc => doc.tbDocumentos_Id === obrigatorioDoc.id)
        );
        if (documentosObrigatorios.length > 0 && !todosDocumentosPresentes) {
            showMessage("Aviso", "Existe documento obrigatório que precisa ser informado", "warning", null);
            return ["Informe todos os documentos obrigatórios para este destino!"];
        }
        return null;
    };

    //Passos do cadastro
    const steps = [
        { text: "Identificação do Destino", icon: faPencilAlt, validateStep: validarIdentificacao },
        { text: "Endereço", icon: faMapMarkerAlt, validateStep: validarEndereco },
        { text: "Documentos", icon: faFilePdf, validateStep: validarDocumentos },
        { text: "Finalizar", icon: faCheck }
    ]


    //Função para pegar o passo ativo do cadastro
    function getSteps() {
        switch (steps[activeStep - 1].text) {
            case "Identificação do Destino": {
                return <IdentificacaoDestino
                    destino={destino}
                    setDestino={setDestino}
                    errors={errors}
                    setErrors={setErrors}
                    campos={camposIdentificacao}
                />
            }
            case "Endereço": {
                return <EnderecoDestino
                    destino={destino}
                    setDestino={setDestino}
                    errors={errors}
                    setErrors={setErrors}
                    campos={camposEndereco}
                />
            }
            case "Documentos": {
                return (
                    <Documentos
                        documentos={listdocumentos}
                        onChangeDocumentos={onChangeDocumentos}
                        state={destino}
                    />
                )
            }
            case "Finalizar": {
                return <FichaDestinoContainer
                    destino={destino}
                    editDestino={() => setActiveStep(1)}
                    editEndereco={() => setActiveStep(2)}
                />
            }
        }
    }

    function loadDocumentos() {
        setLoading(true);
        documento_api.GetListDocumentosCategoria("Destino").then(response => {
            if (response.data?.length === 0) {
                const index = steps.findIndex(step => step.text === "Documentos");
                if (index !== -1)
                    steps.splice(index, 1);
            }
            else {
                const _documentos = response.data.map(value => ({
                    id: value.id,
                    identificacao: value.identificacao,
                    descricao: value.descricao,
                    obrigatorio: value.cadastroDestino === "Obrigatório"
                }));
                setListDocumentos(_documentos);
            }

        }).catch(e => showMessage("Aviso", e.message, "error"))
            .finally(f => setLoading(false));
    }


    //Função para submeter os dados do destino para atualizar ou criar novo
    async function onSubmit() {
        const _destino = { ...destino };
        if (_destino.dataAverbacao === "" || _destino.dataAverbacao === "Data inválida") {
            _destino.dataAverbacao = null;
        }
        if (_destino.validadeLicencaOperacao === "" || _destino.validadeLicencaOperacao === "Data inválida") {
            _destino.validadeLicencaOperacao = null;
        }

        _destino.tiposResiduos = _destino.tiposResiduos.map(value => { return { tipoResiduo_id: value.value } });
        _destino.gps = _destino.latitude + ";" + _destino.longitude;

        let _documentos = [...destino.documentos];
        delete _destino.documentos;

        setLoading(true);

        try {
            let res;
            if (_destino.id) {
                res = await destino_api.Put(_destino);
                _documentos = _documentos.map(doc => ({
                    ...doc,
                    tbDestino_Id: res.data.id
                }));
                await destino_api.PostDocumentos(_documentos);
                showMessage("Sucesso", "Destino atualizado com sucesso", "success", btnVoltar);
            } else {
                res = await destino_api.Post(_destino);
                _documentos = _documentos.map(doc => ({
                    ...doc,
                    tbDestino_Id: res.data.id
                }));
                await destino_api.PostDocumentos(_documentos);
                showMessage("Sucesso", "Destino cadastrado com sucesso", "success", btnVoltar);
            }

        } catch (error) {
            const message = error.message ? error.message || "Erro ao conectar com API" : "Erro ao conectar com API";
            showMessage("Erro", message, "error");
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        loadDocumentos();
    }, [])

    return (
        <>
            <MainCard btnVoltar={btnVoltar}>
                <Row className='mb-4'>
                    <Col md="12" lg="12"><span className="text-danger fw-bold">*</span> Campos obrigatórios</Col>
                </Row>
                <Stepper steps={steps} activeStep={activeStep} setActiveStep={setActiveStep} onSubmit={onSubmit}>
                    {getSteps()}
                </Stepper>
            </MainCard>
        </>
    )
}